import axios from 'axios';
import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Thankyou = () => {
    const navigate = useNavigate();
    const orders = JSON.parse(localStorage.getItem("orders"));
    const cart = JSON.parse(localStorage.getItem("cart"));
    const location = useLocation();

    const bondApiCall = async (orderNumber) => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}call-third-party`,
                {
                    url: `${process.env.REACT_APP_BOND_API_URL}WService=BondTest/jgat0000.w`,
                    body: {
                        Event: "create_purchase_order",
                        UserId: "MV00008",
                        APIKey: "bFjncidncrcbElCm",
                        DeliveryMethod: "Deliver",
                        OrderReference: orderNumber,
                        CustomerInformation: {
                            AccountNumber: "MV00008",
                            TradingPoint: "BI01",
                        },
                        Items: cart.map((item, index) => ({
                            LineRef: index + 1,
                            ProductCode: item.ProductCode,
                            OrderQuantity: item.quantity,
                            ExpectedPrice: item.price,
                            ExpectedDeliveryDate: "2025-10-15",
                        })),
                    },
                }
            );

            const response = res.data?.data?.Response;
            if (response?.["Status:"] === "Error") {
                toast.error(response?.["ErrorDescription:"]);
                return;
            }

            await axios.post(
                `${process.env.REACT_APP_API_URL}call-third-party`,
                {
                    url: `${process.env.REACT_APP_BOND_API_URL}WService=BondWSTest/SWDB/jgat0000.w`,
                    body: {
                        Event: "create_purchase_order",
                        UserId: "MV00008",
                        APIKey: "bFjncidncrcbElCm",
                        DeliveryMethod: "Deliver",
                        OrderReference: orderNumber,
                        CustomerInformation: {
                            AccountNumber: "MV00008",
                            DeliveryAddress: {
                                Name: `${orders.fname} ${orders.lname}`,
                                AddressLine1: orders.address1,
                                AddressLine2: orders.address2,
                                AddressLine3: orders.state,
                                AddressLine4: orders.country,
                                Postcode: orders.zip,
                                Telephone: orders.phone,
                            },
                        },
                        Items: cart.map((item, index) => ({
                            LineRef: index + 1,
                            ProductCode: item.ProductCode,
                            OrderQuantity: item.quantity,
                            ExpectedPrice: item.price,
                            ExpectedDeliveryDate: "2025-10-15",
                        })),
                    },
                }
            );

            localStorage.setItem("bond_done", "true");

        } catch (err) {
            console.log(err);
            toast.error("Something went wrong!");
        }
        localStorage.removeItem("orders");
        localStorage.removeItem("cart");
        window.dispatchEvent(new Event("cartUpdated"));
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const orderNumber = params.get('order_number');
        if (localStorage.getItem("bond_done") === "true") {
            toast.warning("This page cannot be refreshed. Redirecting...");
            navigate("/");
            return;
        }
        if (orderNumber && orders && cart) {
            bondApiCall(orderNumber);
        }
    }, [location.search]);

    return (
        <section className="inner-banner">
            <div className="container-fluid web-padding">
                <div className="row">
                    <div className="col-md-6">
                        <div className="thankyoubanner">
                            <h1>Thankyou</h1>
                            <p>Order placed successfully!</p>
                            <Link to="/" className='theme-btn'>
                                Back to Home <span><img alt="icon" src="images/arrow-right.png" /></span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="inner-banner-right">
                            <img src="images/hero-tires.png" alt="img" />
                        </div>
                    </div>
                </div>
            </div>
            <h2>Tyres</h2>
        </section>
    );
};

export default Thankyou;
